module.exports = __webpack_public_path__ + "static/media/BatmanLego.2c892659.jpg";